import Vue from "vue";
import BootstrapVue from "bootstrap-vue";

// #Topic:
// Vueに読込ませる際にbootstrapvueのコンポーネントの設定を変更可能
// 設定値をobjectで渡す
// 設定値はhttps://bootstrap-vue.js.org/docs/misc/settings参照
var bootstrapSetting = {};

// ※BOOTSTRAPの配色テーマをアプリ用のカスタマイズはPCとモバイルで分岐するので、main.tsで読み込ませる
Vue.use(BootstrapVue, bootstrapSetting);
